<template>
    <div class="form-container">
        <h2>{{ isEdit ? 'Edit Agenda' : 'Create Agenda' }}</h2>
        <hr>

        <div v-if="errorMessage" class="error-message">
            <p>{{ errorMessage }}</p>
        </div>
        <form @submit.prevent="saveAgenda">
            <label>Title <span class="required">*</span></label>
            <input type="text" v-model="agenda.title" placeholder="Agenda Title" required>
            <div v-if="errors.title" class="error-message">{{ errors.title[0] }}</div>

            <label>Group <span class="required">*</span></label>
            <select v-model="agenda.group_id" class="form-control" required>
                <option value="">Select Group</option>
                <option v-for="group in groups" :key="group.id" :value="group.id">{{ group.name }}</option>
            </select>
            <div v-if="errors.group_id" class="error-message">{{ errors.group_id[0] }}</div>

            <label>Description</label>
            <textarea v-model="agenda.description" class="form-control" placeholder="Agenda Description"></textarea>
            <div v-if="errors.description" class="error-message">{{ errors.description[0] }}</div>

            <div class="form-check">
                <input type="checkbox" id="is_active" v-model="agenda.is_active" class="form-check-input" />
                <label for="is_active" class="form-check-label">Active</label>
            </div>

            <div class="btn-group">
                <button type="submit" class="btn btn-sm">{{ isEdit ? 'Update' : 'Add' }}</button>
                <button type="button" class="btn btn-sm cancel-btn"
                    @click="$router.push('/dashboard/agendas')">Cancel</button>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            agenda: { title: '', group_id: '', description: '', is_active: 1 },
            groups: [],
            isEdit: false,
            errorMessage: null,
            errors: {}
        };
    },
    methods: {
        async fetchAgenda() {
            if (this.$route.params.id) {
                this.isEdit = true;
                try {
                    const response = await this.$api.get(`/agendas/${this.$route.params.id}`);
                    this.agenda = { ...response.data };
                    this.agenda.is_active = this.agenda.is_active === 1;
                } catch (error) {
                    this.errorMessage = 'Error fetching agenda data.';
                }
            }
        },
        async fetchGroups() {
            this.$api.get('/groups').then(response => {
                this.groups = response.data;
            });
        },
        async saveAgenda() {
            this.errorMessage = null;
            this.errors = {};
            try {
                const apiCall = this.isEdit ? this.$api.put : this.$api.post;
                const url = this.isEdit ? `/agendas/${this.$route.params.id}` : '/agendas';
                await apiCall(url, this.agenda);
                this.$router.push('/dashboard/agendas');
            } catch (error) {
                if (error.response?.status === 422) {
                    this.errors = error.response.data.errors;
                } else {
                    this.errorMessage = 'An error occurred while saving the agenda. Please try again later.';
                }
            }
        }
    },
    mounted() {
        this.fetchAgenda();
        this.fetchGroups();
    }
};
</script>

<style scoped>
.form-container {
    padding: 20px;
    background: white;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.error-message {
    color: red;
    font-size: 0.9rem;
}

.btn-group {
    margin-top: 10px;
}

.cancel-btn {
    margin-left: 10px;
}
</style>
